/**
 * Convencion de "ofertas reclamables" reusando el modelo de bolsas de consumo
 * (client_limit) sin ningun backend nuevo:
 *
 * - Una bolsa es una OFERTA si su `bagName` empieza con `oferta|`.
 * - El formato completo es `oferta|<titulo>|<descripcion>` — separado por `|`.
 * - `active:false` = oferta pendiente de reclamar (el motor de consumo la
 *   ignora, no cuenta para nada). `active:true` = ya reclamada, bolsa real.
 * - Las plantillas reutilizables viven como bolsas normales, pero bajo un
 *   `clientId` reservado que ningun cliente real va a tener nunca
 *   (`OFFER_TEMPLATES_CLIENT_ID`). "Aplicar" una plantilla = clonar esa
 *   bolsa hacia el clientId real, con `active:false`.
 */

export const OFFER_BAG_PREFIX = 'oferta';
const DELIMITER = '|';

export const OFFER_TEMPLATES_CLIENT_ID = '__offer_templates__';

export const buildOfferBagName = ({ title, description }) =>
  [OFFER_BAG_PREFIX, (title || '').trim(), (description || '').trim()].join(DELIMITER);

/**
 * @param {string} bagName
 * @returns {{ isOffer: boolean, title: string, description: string }}
 */
export const parseOfferBagName = (bagName) => {
  const raw = String(bagName || '');
  const parts = raw.split(DELIMITER);
  if (parts[0]?.trim() !== OFFER_BAG_PREFIX) {
    return { isOffer: false, title: '', description: '' };
  }
  return {
    isOffer: true,
    title: (parts[1] || '').trim(),
    description: (parts[2] || '').trim(),
  };
};

export const isOfferBag = (bagName) => parseOfferBagName(bagName).isOffer;
